<app-loader *ngIf="isDisabled"></app-loader>
<div>
	<div class="row m-0">
		<div class="col"></div>
		<div class="col-auto">
			<button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
				[routerLink]="['/setting/bgvpolicies/add/',0]" [disabled]="isDisabled">
				<i class="bi bi-patch-check-fill" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Add Background Verification Policy':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Background Verification Policies
		</div>
		<div class="card-body p-1">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
						<th>Policy Name</th>
						<th style="width: 80px;">Applicability</th>
						<!-- <th>IsFor Future Date</th>
						<th>Allow For Same Days</th> -->
						<th style="width: 80px;">EmpType</th>
						<th style="width: 100px;">Default Policy</th>

					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
							<div class="text-center"><i
									[routerLink]="['/setting/bgvpolicies/add/',TableData['ESS_bgvPolicyId']]"
									class="bi bi-pencil-square text-warning"></i></div>
						</td>
						<td>{{TableData['PolicyName']}}</td>
						<td style="width: 80px;">{{TableData['WebESSApplicability']}}</td>
						<!-- <td>{{TableData['IsRegularizationForFutureDate']?'Yes':'No'}}</td>
						<td>{{TableData['AllowRegularizationForSameDays']?'Yes':'No'}}</td> -->
						<td style="width: 80px;">{{TableData['EmpType']}}</td>
						<td style="width: 100px;">{{TableData['DefaultPolicy']?'Yes':'No'}}</td>

					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>